module.exports = Amplify;